import { Divider, ImageVideoSlider, Title } from "components/common";
import { renderQuillHtml } from "configs/utils";
import styles from "./index.module.less";
import ExplanationMediaAndActions from "./explanationMediaAndActions";

const ScriptDetailExplanationSection = ({ data }) => {
  return data?.length ? (
    <div className={styles.titleDescription}>
      {data?.map((e, index) => {
        return (
          <div id={`${e?.title}`}>
            <div>
              <Title className={styles.title} level={3}>
                {e.title}
              </Title>
              <div className={styles.description}>
                {renderQuillHtml(e.explanation)}
              </div>
              <ExplanationMediaAndActions explanation={e} />
            </div>

            {index != data?.length - 1 && <Divider />}
          </div>
        );
      })}
    </div>
  ) : (
    <></>
  );
};

export default ScriptDetailExplanationSection;
